import React from "react";
import { Link } from "react-router-dom";

const BlogGrid = () => {
  const blogPosts = [
    {
      id: 1,
      title: "Cuidados Neurológicos para Mascotas",
      excerpt:
        "Aprende sobre los principales cuidados neurológicos que debes tener con tu mascota.",
      image: require("../images/blog/blog-01.jpg"),
      author: "Dr. García",
      date: "Ene 15, 2025",
    },
    {
      id: 2,
      title: "Síntomas Neurológicos en Perros",
      excerpt:
        "Identifica los síntomas neurológicos más comunes en perros y cuándo consultar al veterinario.",
      image: require("../images/blog/blog-02.jpg"),
      author: "Dra. Martínez",
      date: "Ene 10, 2025",
    },
    {
      id: 3,
      title: "Rehabilitación Neurológica Veterinaria",
      excerpt:
        "Descubre cómo la rehabilitación puede ayudar a mascotas con problemas neurológicos.",
      image: require("../images/blog/blog-03.jpg"),
      author: "Dr. López",
      date: "Ene 5, 2025",
    },
  ];

  return (
    <section className="pt-[150px] pb-[110px] lg:pt-[220px]">
      <div className="container max-w-[1390px]">
        <div className="wow fadeInUp text-center mb-14" data-wow-delay=".2s">
          <h2 className="mb-5 text-3xl font-bold text-black dark:text-white sm:text-4xl md:text-[50px]">
            Nuestro Blog
          </h2>
          <p className="text-base text-body">
            Artículos y recursos sobre salud neurológica veterinaria
          </p>
        </div>

        <div className="grid gap-8 md:grid-cols-2 lg:grid-cols-3">
          {blogPosts.map((post) => (
            <div key={post.id} className="wow fadeInUp" data-wow-delay=".2s">
              <div className="overflow-hidden rounded-lg bg-white shadow-card dark:bg-[#15182A] dark:shadow-card-dark">
                <Link to="/blog-details">
                  <img
                    src={post.image}
                    alt={post.title}
                    className="w-full h-[240px] object-cover"
                  />
                </Link>
                <div className="p-8">
                  <div className="flex items-center mb-4 text-sm text-body">
                    <span>{post.author}</span>
                    <span className="mx-2">•</span>
                    <span>{post.date}</span>
                  </div>
                  <h3 className="mb-4 text-xl font-semibold text-black dark:text-white hover:text-primary">
                    <Link to="/blog-details">{post.title}</Link>
                  </h3>
                  <p className="mb-6 text-base text-body">{post.excerpt}</p>
                  <Link
                    to="/blog-details"
                    className="inline-flex items-center text-base font-medium text-primary hover:underline"
                  >
                    Leer más
                    <svg
                      className="ml-2"
                      width="18"
                      height="18"
                      viewBox="0 0 18 18"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M10.5 3.75L15.75 9L10.5 14.25"
                        stroke="currentColor"
                        strokeWidth="2"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                      />
                      <path
                        d="M15.75 9H2.25"
                        stroke="currentColor"
                        strokeWidth="2"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                      />
                    </svg>
                  </Link>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default BlogGrid;
